/**
 * Home – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Home menu icon. */
export default function HomeIcon({ focused, height, width }: Props) {
  const color = Colors['menu']['icon'][focused ? 'focused' : 'unfocused'];
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={`${width || 24 * Screen.widthRatio}`}
      height={`${height || 23 * Screen.widthRatio}`}
      viewBox={'0 0 24 23'}
      fill='none'
    >
      <path
        d='M1 8.02778L11.75 1L22.5 8.02778'
        stroke={color}
        strokeWidth={focused ? 2.5 : 2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M20.1104 12.5V20.6778C20.1104 21.1012 19.7896 21.4444 19.3937 21.4444H4.10485C3.70905 21.4444 3.38818 21.1012 3.38818 20.6778V12.5'
        stroke={color}
        strokeWidth={focused ? 2.5 : 2}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
